module.exports = __webpack_public_path__ + "img/score-3.42e68a8a.png";